import { render, staticRenderFns } from "./LoyaltyProgramPage.vue?vue&type=template&id=7f4cf1a4&scoped=true"
import script from "./LoyaltyProgramPage.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgramPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4cf1a4",
  null
  
)

export default component.exports